import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Typography,
} from "@mui/material";
import { useFormikContext } from "formik";
import useColors from "../../api/hooks/useColors";
import { customerTimezone } from "../../scenes/settings/constants";
import { createTimezoneTitle } from "../../scenes/settings/notifications/pages/GeneralNotifications/FrequencyNotificationsSection/TimezoneSelector";
import { StyledInputLabel, StyledSelect } from "./styles/formFieldStyles";

const TimezoneSelect = ({ ...props }) => {
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();
  const colors = useColors();

  const isTouched = touched?.timezone;
  const fieldError = errors.timezone;
  const hasError = !!isTouched && !!fieldError;
  const errorText =
    hasError && typeof fieldError === "string" ? fieldError : "";

  return (
    <FormControl
      key={"timezone"}
      fullWidth
      margin="dense"
      sx={{
        "& .MuiFormHelperText-root": {
          "&.Mui-error": {
            color: colors.error_500,
          },
        },
        "& .MuiInputLabel-asterisk": {
          color: colors.error_500, // Make the asterisk red
        },
      }}
      {...props}
    >
      <StyledInputLabel id={"timezone-label"}>
        <Typography variant="caption">Timezone</Typography>
      </StyledInputLabel>
      <StyledSelect
        labelId={"timezone-label"}
        displayEmpty
        value={values.timezone}
        IconComponent={ExpandMoreIcon}
        onChange={(event) => {
          setFieldValue("timezone", event.target.value);
        }}
        error={hasError}
        onBlur={handleBlur}
      >
        {Object.keys(customerTimezone).map((ianaTimezone) => (
          <MenuItem key={ianaTimezone} value={ianaTimezone}>
            <Typography variant="caption">
              {createTimezoneTitle(ianaTimezone)}
            </Typography>
          </MenuItem>
        ))}
      </StyledSelect>
      {hasError && <FormHelperText error>{errorText}</FormHelperText>}
    </FormControl>
  );
};

export default TimezoneSelect;
